import { httpClient } from '@/services/http/httpClient'

export type ChangePrivacyProjectProps = {
  projectId: string
  privacy: 'PORTFOLIO_MEMBERS' | 'PRIVATE'
}

export const changePrivacyProject = async ({
  projectId,
  privacy,
}: ChangePrivacyProjectProps) => {
  await httpClient.put(`/projects/portfolio-projects/${projectId}/privacy`, {
    privacy,
  })
}
